import React from 'react';
import PropTypes from 'prop-types';
import pageySitting from 'src/assets/images/pagey-sitting.png';
import Modal from 'src/components/Modal';
import ModalBody from 'src/components/Modal/ModalBody';
import ModalFooter from 'src/components/Modal/ModalFooter';
import styles from 'src/components/Modal/styles.module.css';
import TrackedButton from 'src/components/TrackedButton';
import { TRACKS_THIRD_ARM } from 'src/util/segment-storeless';

export default function IntroModal(props) {
  return (
    <Modal
      namespace="onboardingExperiment"
      width="500px"
      showModal={props.showModal}
    >
      <ModalBody>
        <div className={styles.introModalBody}>
          <div className={styles.pageySittingWrapper}>
            <img src={pageySitting} alt="Pagey sitting" />
          </div>
          <h2 className={styles.centered}>
            {`Welcome aboard, ${props.name}!`}
          </h2>
          <p>
            {`You and your team have ${props.daysLeft} days to explore all of PagerDuty's features for free.`}
          </p>
          <p>
            To help you get started, follow our quick onboarding steps to get all set up
            and using PagerDuty to keep your teams and services online and healthy.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className={styles.introModalFooter}>
          <TrackedButton
            type="button"
            trackName={TRACKS_THIRD_ARM.get_started}
            trackProperties={props.getSegmentProps()}
            onClick={props.startOnboardingFlow}
            data-test="onboarding-experiment-get-started-button"
          >
            Let&apos;s Get Started!
          </TrackedButton>
        </div>
      </ModalFooter>
    </Modal>
  );
}

IntroModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  startOnboardingFlow: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  daysLeft: PropTypes.number.isRequired,
  getSegmentProps: PropTypes.func.isRequired,
};
